import { assocPath, dissocPath, path as rPath } from 'ramda';

export class ValidationHelpers {
  constructor() {
    this.errors = {};
  }

  getFieldError = path => {
    return rPath(path, this.errors);
  };

  setFieldError = (path, value) => {
    this.errors = assocPath(path, value, this.errors);
  };

  removeFieldError = path => {
    this.errors = dissocDeep(path, this.errors);
  };

  resetErrors = () => {
    this.errors = {};
  };

  get isFormValid() {
    return !Object.keys(this.errors).length;
  }
}

export function dissocDeep(keys, target) {
  const result = dissocPath(keys, target);

  keys.splice(-1);

  const valueByUpdatedPath = rPath(keys, result);

  if (!keys.length || !valueByUpdatedPath || Object.keys(valueByUpdatedPath).length) {
    return result;
  }

  return dissocDeep(keys, result);
}
